import React, { createContext, useContext, useState, useCallback } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

// Create Context
const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    variant: "success", // success | danger | warning | info
  });

  const showNotification = useCallback((message, variant = "success") => {
    setNotification({ show: true, message, variant });
  }, []);

  const hideNotification = () =>
    setNotification((prev) => ({ ...prev, show: false }));

  return (
    <NotificationContext.Provider
      value={{ showNotification, hideNotification }}
    >
      {children}

      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={notification.variant}
          show={notification.show}
          onClose={hideNotification}
          delay={3000}
          autohide
        >
          <Toast.Body className="text-white">{notification.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </NotificationContext.Provider>
  );
};
